import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image2 from "./images/image/image4.jpeg";
import image1 from "./images/image/image1.jpeg";
import image3 from "./images/image/image3.jpeg" ;


const HackEsprit = () => {
    const images = [image1,image2,image3];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">GreenAct Esprit</h2>
        <span className="section__subtitle">Ideation phase winner🥇</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎉 Our team <strong>TechnoTitans</strong> won the ideation phase in the <strong>Green Act Hackathon</strong>!
                    </p>
                    <p className='redRadio__text'>
                        🌱 With our <strong>AI-powered soil management system</strong>, we clinched first place in the ideation phase and are now gearing up to implement our project on our university campus.
                    </p>
                    <p className='redRadio__text'>
                        🎯 Our solution not only won the hearts of the judges but also made a significant impact on <strong>Sustainable Development Goals 13, 8, and 3</strong>.
                    </p>
                    <p className='redRadio__text'>
                        🚀 Stay tuned for more updates on our journey towards a greener future! 🌱🏆
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default HackEsprit;
